import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';

export const styles = StyleSheet.create({
  rowDevice: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderRadius: theme.radius.m,
    backgroundColor: theme.palette.mono100,
  },
  rowDeviceError: {
    backgroundColor: theme.palette.redLight,
  },
  rowDeviceWarning: {
    backgroundColor: theme.palette.orangeLight,
  },
  text: {
    flex: 1,
    rowGap: 4,
  },
  name: {
    fontSize: 14,
    lineHeight: 20,
    color: theme.palette.mono800,
    fontFamily: theme.fonts.medium,
    fontVariant: ['tabular-nums'],
  },
  subtext: {
    fontSize: 12,
    lineHeight: 16,
    color: theme.palette.mono600,
    fontFamily: theme.fonts.regular,
    fontVariant: ['tabular-nums'],
  },
});
